<template>
  <canvas
    :id="canvasId"
    :class="classes"
    :style="canvasStyle"
    :width="width"
    :height="height"
    @mousedown="startDraw"
    @mousemove="draw"
    @mouseup="stopDraw"
    @touchstart="startDraw"
    @touchmove="draw"
    @touchend="stopDraw"
  />
</template>

<script>
import VueDrawingCanvas from 'vue-drawing-canvas'

export default {
  name: 'VueDrawingCanvasWrapper',
  extends: VueDrawingCanvas,
  computed: {
    canvasStyle() {
      return this.styles || {};
    }
  },
  methods: {
    // 重写坐标获取方法以支持CSS旋转
    getCoordinates(event) {
      let x, y;

      if (event.touches && event.touches.length > 0) {
        let canvas = document.querySelector('#' + this.canvasId);
        let rect = canvas.getBoundingClientRect();
        
        // 获取原始触摸坐标（相对于视口）
        let clientX = event.touches[0].clientX;
        let clientY = event.touches[0].clientY;
        
        // 调试信息
        // console.log('原始触摸坐标:', { clientX, clientY });
        // console.log('Canvas rect:', rect);
        
        x = clientX - rect.left;
        y = clientY - rect.top;
        
        // console.log('最终canvas坐标:', { x, y });
      } else {
        x = event.offsetX;
        y = event.offsetY;
      }

      // 确保坐标在合理范围内
      x = Math.max(0, Math.min(x, Number(this.width)));
      y = Math.max(0, Math.min(y, Number(this.height)));

      return {
        x: x,
        y: y
      };
    },
    // 重写drawBackgroundImage方法以支持crossOrigin
    async drawBackgroundImage() {
      if (!this.loadedImage) {
        return new Promise((resolve, reject) => {
          if (!this.backgroundImage) {
            resolve();
            return;
          }

          const image = new Image();
          
          // 设置crossOrigin以解决跨域问题
          image.crossOrigin = "anonymous";
          
          image.onload = () => {
            try {
              this.context.drawImage(image, 0, 0, Number(this.width), Number(this.height));
              this.loadedImage = image;
              resolve();
            } catch (error) {
              console.warn('绘制背景图失败:', error);
              // 如果crossOrigin失败，尝试不设置crossOrigin
              this.drawBackgroundImageFallback().then(resolve).catch(reject);
            }
          };
          
          image.onerror = () => {
            console.warn('背景图加载失败，尝试不使用crossOrigin');
            // 如果crossOrigin失败，尝试不设置crossOrigin
            this.drawBackgroundImageFallback().then(resolve).catch(reject);
          };
          
          image.src = this.backgroundImage;
        });
      } else {
        this.context.drawImage(this.loadedImage, 0, 0, Number(this.width), Number(this.height));
      }
    },
    
    // 回退方法：不使用crossOrigin
    async drawBackgroundImageFallback() {
      return new Promise((resolve, reject) => {
        const image = new Image();
        
        image.onload = () => {
          try {
            this.context.drawImage(image, 0, 0, Number(this.width), Number(this.height));
            this.loadedImage = image;
            resolve();
          } catch (error) {
            console.error('背景图绘制完全失败:', error);
            reject(error);
          }
        };
        
        image.onerror = (error) => {
          console.error('背景图加载完全失败:', error);
          reject(error);
        };
        
        // 不设置crossOrigin
        image.src = this.backgroundImage;
      });
    }
  },
  watch: {
    backgroundImage(newVal) {
      try {
        this.loadedImage = null;
        if (newVal && this.context) {
          this.drawBackgroundImage();
        }
      } catch (e) {
        
      }
    }
  }
}
</script>
